import { Box, ButtonBase, Typography } from "@mui/material";
import ChipsBox from "../chips-box";
import CommonTextBox from "../TextBoxes/common-text-box";
import CommonLabel from "../label";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import CATEGRORY from "../../assets/icons/category.png";

const getCategoryIconPosition = (name, position) => {
  const normalizedName = (name || "").trim().toLowerCase();

  if (position) {
    return position;
  }

  const fallbackPositions = {
    foundation: "-11px -11px",
    concealer: "-11px -89px",
    "compact powder": "-89px -11px",
    primer: "-89px -89px",
  };

  return fallbackPositions[normalizedName] || "center";
};

const CategorySection = (props) => {
  const navigate = useNavigate();

  const [selectedMainCategory, setSeletedMainCategory] =
    useState("All Categories");

  return (
    <>
      <Box>
        <ChipsBox
          itemList={[
            "All Categories",
            "Beauty"
            // "Bath & Spa",
            // "Skincare",
            // "Hair Styling",
            // "Sexual Wellness",
            // "Miscellaneous"
          ]}
          highlightChip={selectedMainCategory}
          handleCategoryChange={(name) => {
            setSeletedMainCategory(name);
          }}
        />
      </Box>

      {/* section for sub category */}
      <Box
        sx={{
          display: "grid",
          gridAutoFlow: "column",
          gridTemplateRows: "repeat(2,auto)",
          gridAutoColumns: { xs: "78px", sm: "90px", md: "96px" },
          columnGap: { xs: "14px", sm: "18px", md: "22px" },
          rowGap: { xs: "18px", sm: "22px" },
          overflowX: "auto",
          overflowY: "hidden",
          width: "100%",
          WebkitOverflowScrolling: "touch",
          scrollbarWidth: "none",
        }}
      >
        {props?.category.map((category, index) => {
          const name = category?.category_name || "";
          const image = category?.category_image || "";
          const main = category?.main_category_name || "";
          const position = category?.category_position || "";
          if (
            selectedMainCategory !== "All Categories" &&
            selectedMainCategory.toLowerCase() !== main
          ) {
            return <></>;
          }

          return (
            <ButtonBase
              key={index}
              type="button"
              onClick={() => {
                navigate(`/category?main=${main}&sub=${name}`);
              }}
              aria-label={name}
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "flex-start",
                gap: "6px",
                p: 0,
                textAlign: "center",
              }}
            >
              <Box
                sx={{
                  width: {
                    xs: 56,
                    sm: 60,
                    md: 64,
                  },
                  height: {
                    xs: 56,
                    sm: 60,
                    md: 64,
                  },
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <Box
                  component={"img"}
                  src={image}
                  alt={name}
                  loading="lazy"
                  decoding="async"
                  sx={{
                    maxWidth: "100%",
                    maxHeight: "100%",
                    objectFit: "contain",
                    display: "block",
                  }}
                ></Box>
              </Box>
              <CommonLabel
                variant={"body2"}
                title={name}
                sx={{
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                {name}
              </CommonLabel>
            </ButtonBase>
          );
        })}
      </Box>
    </>
  );
};

export default CategorySection;
